import type { GroupPanelViewState, SerializedGridObject } from 'dockview';
import { compact } from 'lodash-es';

/**
 * Remove the specified views and panels from the grid
 * @param removedPanels The views to remove
 * @param grid The grid to remove the views from
 * @returns The grid with the views removed or undefined if all views are removed
 */
export function removeViewsFromGrid(removedPanels: string[], grid: SerializedGridObject<GroupPanelViewState>) {
  if (removedPanels.length > 0) {
    if (Array.isArray(grid.data)) {
      grid.data = compact(grid.data.map(date => removeViewsFromGrid(removedPanels, date)));
      if (grid.data.length === 0) {
        return undefined;
      }
    } else {
      grid.data.views = grid.data.views.filter(view => !removedPanels.includes(view));
      if (grid.data.views.length > 0) {
        grid.data.activeView =
          grid.data.activeView && grid.data.views.includes(grid.data.activeView)
            ? grid.data.activeView
            : grid.data.views[0];
      } else {
        return undefined;
      }
    }
  }
  return grid;
}
